<template>
  <Modal v-model="importBackupOrderModal" :title="$t('key1006842')" :transfer="false" :mask-closable="false"
    width="750" @on-visible-change="importBackupOrderChange">
    <Form ref="importBackupOrderForm" :model="importBackupOrderForm" :label-width="labelWidth" @submit.native.prevent>
      <Row align="middle" justify="space-between">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006843')" prop="ymsWarehouseId" class="required_style_label">
            <Select filterable class="width_300" v-model="importBackupOrderForm.ymsWarehouseId">
              <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001227')" prop="warehouseId" class="required_style_label">
            <Select filterable class="width_300" v-model="importBackupOrderForm.warehouseId">
              <Option v-for="item in shippingWarehouseList" :key="item.warehouseId" :value="item.warehouseId">{{ item.warehouseName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col span="24" class="no_margin_style mb10">
          <Form-item :label="$t('key1000262')" prop="file" class="required_style_label">
            <div class="flex align-items-center">
              <Upload
                :disabled="!importBackupOrderForm.ymsWarehouseId"
                style="display: inline-block"
                :headers="headObj"
                ref="uploadRef"
                name='files'
                :data="uploadData"
                :show-upload-list="false"
                :action="uploadAction"
                :before-upload="beforeHandleUpload"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :max-size="uploadFilesMaxSize"
                :format="importFormat">
                <Button class="mr10" :disabled="!importBackupOrderForm.ymsWarehouseId">
                  <i class="iconfont">&#xe663;</i>
                  {{ $t('key1000266') }}
                </Button>
              </Upload>
              <a class="ml40" @click="download">{{ $t('key1000264') }}</a>
            </div>
          </Form-item>
        </Col>
        <Col span="24" class="no_margin_style mb10" v-if="excleFile">
          <Form-item :label="$t('key1000334')">
            <span>{{ excleFile.name }}</span>
          </Form-item>
        </Col>
        <Col span="24" push="2">
          <div class="tips_styles">
            {{ $t('key1000270') }}<br/>
            {{ $t('key1006844') }}<br/>
            {{ $t('key1006845') }}<br/>
            {{ $t('key1006846') }}<br/>
            {{ $t('key1006847') }}
          </div>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="importBackupOrderModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="importBackupOrderBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllWarehouseData, getSupplierWarehouseData, getEnumList, getDataSetBatchList, getImportTemplate} from "@/utils/common";

export default {
  name: 'importBackupOrderModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      importBackupOrderModal: false,
      importBackupOrderForm: {
        ymsWarehouseId: null,
        outboundType: null,
        warehouseId: null
      },
      warehouseList: [],
      uploadData: {},
      uploadAction: api.post_packageInfo_excelImportStockOrder,
      importFormat: ['xls', 'xlsx'],
      excleFile: null,
      formatError: false,
      shippingWarehouseList: [],
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 出库单类型
    outboundTypeList() {
      const ENUM_KEY = 'PackageInfoOutboundTypeSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list = list.filter(item => [2, 3].includes(item.value));
      return list;
    }
  },
  methods: {
    // 初始化数据
    async initImportBackupOrderData() {
      let enumKeyList = ['PackageInfoOutboundTypeSupplierEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);

      let query = {
        stockedWarehouse: 1,
        servicePlatform: 'core'
      };
      this.warehouseList = await getAllWarehouseData(query);
      let newData = await getSupplierWarehouseData({warehouseStatus: 0});
      this.shippingWarehouseList = [];
      if (newData.length > 0) {
        this.shippingWarehouseList = newData.filter((item) => {
          let ymsWarehouseCollectionSettingList = item.ymsWarehouseCollectionSettingList || [];
          let ymsWarehouseDeliverySettingList = item.ymsWarehouseDeliverySettingList || [];
          return ymsWarehouseCollectionSettingList.length > 0 || ymsWarehouseDeliverySettingList.length > 0;
        });
      }
      this.importBackupOrderModal = true;
    },
    // 上传文件之前
    beforeHandleUpload(excleFile) {
      let v = this;
      const fileExtension = excleFile.name.split('.').pop().toLowerCase();
      if (!v.importFormat.includes(fileExtension)) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006304'));
        return false;
      } else {
        v.excleFile = excleFile;
        v.updateQuery();
        return false;
      }
    },
    // 实时更新参数
    updateQuery() {
      let v = this;
      let obj = {
        outboundType: 2,
        ymsWarehouseId: v.importBackupOrderForm.ymsWarehouseId,
        warehouseId: v.importBackupOrderForm.warehouseId
      };
      v.uploadData = Object.assign({}, obj);
    },
    // 上传文件失败
    uploadError() {
      this.formatError = true;
      this.importBackupOrderModal = true;
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      return false;
    },
    // 上传文件成功
    uploadSuccess(res, file, fileList) {
      let v = this;
      let code = res.code;
      if (code === 0) {
        v.importBackupOrderModal = false;
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
        setTimeout(() => {
          v.$emit('updateData', true);
        }, 1000);
      }
    },
    // 确定
    importBackupOrderBtn() {
      let v = this;
      if (v.importBackupOrderForm.ymsWarehouseId && v.importBackupOrderForm.warehouseId) {
        if (v.excleFile) {
          v.updateQuery();
          v.$refs['uploadRef'].post(v.excleFile); // 手动上传
          if (!v.formatError) {
            setTimeout(() => {
              v.excleFile = null;
              v.importBackupOrderModal = false;
            }, 2000);
          }
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000254'));
          return false;
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006841'));
        return false;
      }
    },
    // 模板下载
    download() {
      getImportTemplate('supplierStockOrder');
    },
    // 监听弹窗
    importBackupOrderChange(value) {
      if (!value) {
        this.$refs['importBackupOrderForm'].resetFields();
        this.warehouseList = [];
        this.excleFile = null;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.no_margin_style {
  /deep/ .ivu-form-item {
    margin: 0 !important;
  }
}

.tips_styles {
  color: #9a9797;
  margin: 12px 0 20px 0;
}
</style>
